import React from "react";
import { SelectItem, SelectSeparator } from "@/components/ui/select";

// Unified report style list — IDENTICAL on Reports and Team Reports.
// `value` is the backend style key (unchanged, so generation behavior is unaffected);
// `key` maps to the i18n label/description under reportStyles.*.
export const REPORT_STYLES = [
  { value: "Executive summary", key: "executive" },
  { value: "Standard", key: "standard" },
  { value: "Narrative", key: "narrative" },
  { value: "Bullet points", key: "bullets" },
  { value: "Technical/detailed", key: "technical" },
  { value: "Formal/official", key: "formal" },
];

export const CUSTOM_STYLE = "Custom template";

export const STYLE_KEY_BY_VALUE = {
  "Executive summary": "executive",
  "Standard": "standard",
  "Narrative": "narrative",
  "Bullet points": "bullets",
  "Technical/detailed": "technical",
  "Formal/official": "formal",
  "Custom template": "custom",
};

// Compact label for the closed trigger (label only — descriptions live in the dropdown).
export const styleTriggerLabel = (t, value) => {
  const k = STYLE_KEY_BY_VALUE[value];
  return k ? t(`reportStyles.${k}.label`) : value;
};

const Opt = ({ t, k, value, testid }) => (
  <SelectItem key={value} value={value} data-testid={testid}>
    <span className="flex flex-col py-0.5">
      <span className="font-medium">{t(`reportStyles.${k}.label`)}</span>
      <span className="text-xs text-slatebody whitespace-normal leading-snug">{t(`reportStyles.${k}.desc`)}</span>
    </span>
  </SelectItem>
);

// Renders the 6 unified styles + a thin divider + Custom Template (last).
export const ReportStyleOptions = ({ t, customTestId }) => (
  <>
    {REPORT_STYLES.map((s) => <Opt key={s.value} t={t} k={s.key} value={s.value} />)}
    <SelectSeparator />
    <Opt t={t} k="custom" value={CUSTOM_STYLE} testid={customTestId} />
  </>
);
